import React from 'react';
import FlexCard from '../components/General/FlexCard';
import {ColorModeSwitcher} from '../components/General/ColorModeSwitcher';

const Settings = () => {
  return (
    <FlexCard>
      Color Mode Switcher:
      <ColorModeSwitcher />
    </FlexCard>
  );
};

export default Settings;
